import { Injectable } from '@angular/core';
import { Resource, Service } from 'ngx-jsonapi';
import { lastValueFrom } from 'rxjs';

export class MediaAsset extends Resource {
  public override attributes = {
    url: null as string | null,
    caption: '',
    event_id: null as number | null,
    event_title: '',
    sort_order: 0,
    file: null as File | null,
  };

  public override relationships = {};
}

@Injectable({
  providedIn: 'root',
})
export class MediaAssetService extends Service<MediaAsset> {
  public override resource = MediaAsset;
  public override type = 'MediaAsset';
  public override path = '/api/media-assets';

  public async fetchCurrentUserProfileGallery(): Promise<MediaAsset[]> {
    const collection = await lastValueFrom(this.all({
      sort: ['sort_order'],
      page: {
        number: 1,
        size: 200,
      },
    }));

    return [...collection.data];
  }

  public async uploadProfileGalleryImage(file: File, eventId: string | null): Promise<MediaAsset> {
    const asset = this.new();
    asset.attributes.file = file;
    asset.attributes.event_id = eventId ? Number(eventId) : null;

    await lastValueFrom(asset.save({ saveTransport: 'multipart' }));
    return asset;
  }

  public async assignProfileGalleryEvent(assetId: string, eventId: string | null): Promise<MediaAsset> {
    const asset = await this.getCurrentUserProfileGalleryAsset(assetId);
    asset.attributes.event_id = eventId ? Number(eventId) : null;

    await lastValueFrom(asset.save());
    return asset;
  }

  public async deleteProfileGalleryAsset(assetId: string): Promise<void> {
    await lastValueFrom(this.delete(assetId));
  }

  private async getCurrentUserProfileGalleryAsset(assetId: string): Promise<MediaAsset> {
    const cachedAsset = this.getOrCreateResource(assetId);
    if (!cachedAsset.is_new) {
      return cachedAsset;
    }

    return lastValueFrom(this.get(assetId));
  }
}
